;(function () {

"use strict" ;
  
var CustomObjectTooltipTemplate = require('./templates/custom-object-tooltip.html');
var CustomObjectListTemplate = require('./templates/custom-object-list.html');

var customObjectTooltip;

var CustomObjectTooltip = Backbone.View.extend({
  initialize: function () {
    this.$template = $(_.template(CustomObjectTooltipTemplate)());
    this.$el.append(this.$template);
    this.renderItems();
  },
  renderItems: function (data) {
    if (!data) {
      data = window.data;
    }
    this.$template.find('#custom-object-list').empty();
    var list = $(_.template(CustomObjectListTemplate)(data));
    this.$template.find("#custom-object-list").append(list);
  },
  show: function (view) {
    this.view = view;
    this.$el.appendTo(view.$el);
    this.$el.show();
  },
  hide: function (view) {
    this.$el.hide();
    this.$el.find('input.custom-object-filter').val('');
  },
  events: {
    'click li a': function (e) {
      var id = $(e.currentTarget).data('id');
      this.view.$input.val(id);
      return false;
    }
  }
})

$(document).on('ready turbolinks:render', function() {
  if (window.data.page === 'upsert') {
    customObjectTooltip = new CustomObjectTooltip();  
  }
});

var CustomObjectView = Backbone.View.extend({
  initialize: function () {
    console.log('init custom object view');
    this.$input = this.$el.find('input');

    if (this.$input.val().indexOf('CUSTOM_OBJECT:') === 0) {
      this.$input.val(this.$input.val().replace('CUSTOM_OBJECT:', ''));
    }

    this.tooltip = customObjectTooltip;
  },
  showModal: function () {
    this.tooltip.show(this);
  },
  hideModal: function () {
    this.tooltip.hide(this);
    this.filter = '';
    this.tooltip.renderItems();
  },
  filterInput() {
    var data = _.clone(window.data);
    var customObjects = data.customObjects;
    var filter = this.filter;

    var tmp = [];
    customObjects.forEach(function (obj) {
      if (!obj.handle || !obj.handle.value) { return; }

      var handle = obj.handle.value;

      if (handle.indexOf(filter) !== -1) {
        tmp.push(obj);
      }
    });

    data.customObjects = tmp;
    this.tooltip.renderItems(data);
  },
  events: {
    'mouseenter': 'showModal',
    'mouseleave': 'hideModal',
    'keyup .custom-object-filter': function (e) {
      this.filter = $(e.currentTarget).val();
      this.filterInput();
      console.log('here');
      console.log(this.filter);
    }
  }
})

module.exports = CustomObjectView;

}());